<script setup lang="ts">
import type { FormkitCommonProps } from "@/components/ui/input/formkit/formkit.types";
import type { THeatPumpBrandDto } from "@/types/backoffice/dto/heatpump/heatpump-brand-dto.ts";
import type { FormKitFrameworkContext } from "@formkit/core";
/**
 * @deprecated Use non-formkit-specific HeatpumpBrandAutocompleteInput instead
 */
import type { AutoCompleteCompleteEvent, AutoCompleteItemSelectEvent } from "primevue/autocomplete";
import type { PropType } from "vue";

import { useMutation } from "@tanstack/vue-query";
import { ref } from "vue";

import BackofficeApi from "@/api/backoffice/backoffice-api.ts";
import { HeatPumpQueryKeys } from "@/api/backoffice/heatpump/heatpump-query-keys.ts";
import { DATA_TEST_IDS } from "@/constants/data-test-ids";
import { useFormkitComputedValue } from "@/hooks/common/use-formkit";

import AutoComplete from "primevue/autocomplete";

export type FormKitHeatpumpBrandAutocompleteProps = FormkitCommonProps;

const props = defineProps({
  context: {
    type: Object as PropType<
      FormKitFrameworkContext<THeatPumpBrandDto | string> & FormKitHeatpumpBrandAutocompleteProps
    >,
  },
});

const brandSuggestions = ref<Array<THeatPumpBrandDto>>([]);

const { mutateAsync: findBrands } = useMutation({
  mutationKey: HeatPumpQueryKeys.findBrands(),
  mutationFn: (query: string) => BackofficeApi.findHeatPumpBrands({ queries: { query } }),
});

const search = async (event: AutoCompleteCompleteEvent) => {
  try {
    brandSuggestions.value = await findBrands(event.query);
  } catch (e) {
    console.error(e);
  }
};

const value = useFormkitComputedValue<THeatPumpBrandDto | string | null>(props.context);
</script>

<template>
  <AutoComplete
    v-model="value"
    :suggestions="brandSuggestions"
    option-label="name"
    :name="props.context?.name"
    :placeholder="props.context?.placeholder"
    class="w-full"
    :disabled="props.context?.disabled"
    input-class="w-full"
    dropdown
    v-bind="$attrs"
    :data-test-id="DATA_TEST_IDS.components.heatpumpBrandAutocomplete.input()"
    @complete="search"
    @item-select="(e: AutoCompleteItemSelectEvent) => (value = e.value)"
  />
</template>

<style scoped></style>
